export default __webpack_public_path__ + "static/media/admin-message-icon.b05caaf4.svg";